module.exports = __webpack_public_path__ + "img/icon_alrt.df8ba982.svg";